export default __webpack_public_path__ + "static/media/chat.1ce69829.svg";